import { InputProps, SelectInput } from "react-admin"

import { typeChoices } from "../constants"

export const SelectTypeInput: React.FC<InputProps> = (props) => (
  <SelectInput {...props} choices={typeChoices} />
)
